module.exports = __webpack_public_path__ + "static/media/ts8cr658.9676979c.png";